import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "../components/NavBar"; 
import LoginModal from "../components/LoginModal";
import HeroSection from "../components/HeroSection";
import CompanyOverview from "../components/CompanyOverview";
import LegalityTimeline from "../components/LegalityTimeline";
import WhyChooseUs from "../components/WhyChooseUs";
import TestimonialSlider from "../components/TestimonialSlider";
import AboutCompany from "../components/AboutCompany";
import GallerySection from "../components/GallerySection";
import NewsSection from "../components/NewsSection";
import ContactMap from "../components/ContactMap";
import LeadershipSection from "../components/LeadershipSection";
import Footer from "../components/Footer";
import ScrollToTop from "../components/ScrollToTop"; // import komponen scroll

function MainPage() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (user) => {
    if (user.role === "Admin") {
      localStorage.setItem("isAdmin", "true");
      navigate("/admin", { replace: true });
    }
  };

  return (
    <div className="main-page-container relative">
      <NavBar onOpenLogin={() => setIsLoginOpen(true)} />

      <LoginModal
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        onLogin={handleLogin}
      />

      <section id="beranda">
        <HeroSection />
      </section>
      <section id="tentang-perusahaan">
        <CompanyOverview />
      </section>
      <section id="legality">
        <LegalityTimeline />
      </section>
      <section id="tentang-kami">
        <AboutCompany />
      </section>
      <section id="tim-kami">
        <LeadershipSection />
      </section>
      <section id="layanan">
        <WhyChooseUs />
      </section>
      <section id="galeri">
        <GallerySection />
      </section>
      <section id="testimoni">
        <TestimonialSlider />
      </section>
      <section id="berita">
        <NewsSection />
      </section>
      <section id="kontak">
        <ContactMap />
      </section>

      <Footer />

      {/* Tombol Scroll To Top */}
      <ScrollToTop />
    </div>
  );
}

export default MainPage;
